export default __webpack_public_path__ + "static/media/banner.b8d7655f.png";